// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CollectionContextMenu_dropdown__3jtN9","ellipsis":"CollectionContextMenu_ellipsis__3LRxo"};